/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useLocation } from "@reach/router";
import { graphql, navigate } from "gatsby";
import * as React from "react";
import Layout from "../components/layout";
import NewsCategoryItem from "../components/news/news-category-item";
import WorkList from "../components/works/work-list";
import { NewsListItemModel } from "../models/ListItemModel";

type DataProps = {
  data: {
    allWpNews: {
      nodes: NewsListItemModel[];
    };
  };
};

const NewsPage = ({ data }: DataProps) => {
  const location = useLocation();

  const [category, setCategory] = React.useState("all");
  const [items, setItems] = React.useState<any[]>([]);

  const onSelect = (label: string) => {
    const _ = label.toLowerCase();
    if (_ === "all") {
      navigate("/news/");
    } else {
      navigate(`/news/?category=${_}`);
    }
  };

  React.useEffect(() => {
    const query = new URLSearchParams(location.search);
    const c = query.get("category") ?? "all";
    setCategory(c);

    const tmp = data?.allWpNews?.nodes ?? [];
    if (c !== "all") {
      const _ = tmp.filter((v) => v.news_category.category?.includes(c));
      setItems(_);
    } else {
      setItems(tmp);
    }
  }, [location]);

  return (
    <Layout title="NEWS">
      <main
        css={css`
          padding-top: 88px;
          @media (min-width: 767px) {
            padding-top: 147px;
          }
          @media (min-width: 1299px) {
            padding-top: 159px;
          }
        `}
      >
        <div style={{ margin: "0 25px" }}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              margin: "0 0 25px",
            }}
          >
            <NewsCategoryItem
              label="ALL"
              current={category}
              onSelect={onSelect}
            />
            <NewsCategoryItem
              label="PROJECT"
              current={category}
              onSelect={onSelect}
            />
            <NewsCategoryItem
              label="MEDIA"
              current={category}
              onSelect={onSelect}
            />
            <NewsCategoryItem
              label="STUDIO"
              current={category}
              onSelect={onSelect}
            />
          </div>
          <WorkList path="/news/" items={items} />
        </div>
      </main>
    </Layout>
  );
};
export default NewsPage;

export const pageQuery = graphql`
  query {
    allWpNews(sort: { fields: [date], order: DESC }) {
      nodes {
        title
        title_en {
          titleEn
        }
        slug
        date
        news_category {
          category
        }
        thumbnail {
          thumbnailContent {
            type
            movie {
              guid
            }
            images {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                    fluid {
                      originalImg
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
